import { ACTIONPLANS_MODULE_NAME } from '@/store/modules/actionplans/constants';
import registerTypes from './types';
import registerStatus from './status';
import registerOrigins from './origins';
import registerActions from './actions';
import registerAuthors from './authors';
import module from './module';
import plugins from './plugins';

export default (store) => {
  const MODULE_NAME = ACTIONPLANS_MODULE_NAME;
  const MODULE_PATH = MODULE_NAME.join('/');

  store.registerModule(MODULE_NAME, module);

  plugins(store, MODULE_PATH);

  registerTypes(store);
  registerStatus(store);
  registerOrigins(store);
  registerActions(store);
  registerAuthors(store);
};
